import type { IconType } from 'react-icons'
import { FaLocationDot } from 'react-icons/fa6'
import { IoMdCalendar } from 'react-icons/io'
import {
  MdArticle,
  MdDescription,
  MdPerson,
  MdPersonPin,
  MdPodcasts,
  MdMap,
} from 'react-icons/md'

type DrawerField = {
  id: string
  route: string
  icon: IconType
  valueItem: string
  hiddenForLevels: number[]
}

export const homeDrawerFields: DrawerField[] = [
  {
    id: '1',
    route: '/clientes',
    hiddenForLevels: [3],
    icon: MdPerson,
    valueItem: 'Clientes',
  },
  {
    id: '6',
    route: '/clientes-proximos',
    hiddenForLevels: [3],
    valueItem: 'Clientes próximos',
    icon: FaLocationDot,
  },
  {
    id: '2',
    route: '/pedidos',
    hiddenForLevels: [3],
    icon: MdDescription,
    valueItem: 'Pedidos',
  },
  {
    id: '7',
    route: '/visitas',
    hiddenForLevels: [3],
    icon: MdPersonPin,
    valueItem: 'Promotor x Visitas',
  },
  {
    id: '8',
    route: '/rotas',
    hiddenForLevels: [3],
    icon: MdMap,
    valueItem: 'Rotas',
  },
  {
    id: '3',
    route: '/transmitir',
    hiddenForLevels: [3],
    icon: MdPodcasts,
    valueItem: 'Transmitir',
  },
  {
    id: '4',
    route: '/relatorios',
    hiddenForLevels: [],
    icon: MdArticle,
    valueItem: 'Relatórios',
  },
  {
    id: '5',
    route: '/agendamentos',
    hiddenForLevels: [3],
    icon: IoMdCalendar,
    valueItem: 'Agenda',
  } /*
  {
    id: '7',
    route: '/documentacao',
    icon: MdHelp,
    valueItem: 'Ajuda',
  }, */,
]